import React, { useState, useEffect } from 'react';
import {
    Button,
    Grid,
    Typography,
    Paper,
    FormControl,
    Select,
    MenuItem,
} from '@mui/material';

const BulkEditPanel = ({
    selectedRows,
    onBulkUpdate
}) => {
    const [approvedNgos, setApprovedNgos] = useState([]);
    const [bulkAssignedTo, setBulkAssignedTo] = useState('all');
    const [bulkAllocatedTo, setBulkAllocatedTo] = useState('all');
    const [bulkDistributed, setBulkDistributed] = useState('all');

    // const [confirmOpen, setConfirmOpen] = useState(false);
    // const [pendingUpdates, setPendingUpdates] = useState([]);

    useEffect(() => {
        const fetchApprovedNgos = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_NgoInformationApi}?type=registration`
                );
                const responseData = await response.json();
                const filteredNgos = responseData.data.filter(ngo => 
                    ["Approved", "Delivered", "Dispatched"].includes(ngo.Status)
                );
                setApprovedNgos(filteredNgos.map(ngo => ngo.organizationName));
            } catch (error) {
                console.error("Error fetching NGO data:", error);
            }
        };

        fetchApprovedNgos();
    }, []);

    const handleBulkUpdate = () => {
        const updates = [];

        if (bulkAssignedTo !== 'all') {
            updates.push({ field: 'Assigned To', value: bulkAssignedTo });
        }

        if (bulkAllocatedTo !== 'all') {
            updates.push({ field: 'Allocated To', value: bulkAllocatedTo });
        }
        if (bulkDistributed !== 'all') {
            updates.push({ field: 'Distributed', value: bulkDistributed });
        }


        if (updates.length > 0) {
            onBulkUpdate(updates);
        }
    };

    return (
        <>
            <Paper elevation={1} sx={{ p: 2, mb: 2 }}>
                <Typography variant="h6" gutterBottom>
                    Bulk Edit ({selectedRows.length} selected)
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <Typography variant="subtitle2" gutterBottom>
                                Assigned To
                            </Typography>
                            <Select
                                value={bulkAssignedTo}
                                onChange={(e) => setBulkAssignedTo(e.target.value)}
                                variant="outlined"
                                size="small"
                            >
                                <MenuItem value="all">No Change</MenuItem>
                                <MenuItem value="Shweta Deshmukh">Shweta Deshmukh</MenuItem>
                                <MenuItem value="Vishwanath">Vishwanath</MenuItem>
                                <MenuItem value="Bhavesh">Bhavesh</MenuItem>
                                <MenuItem value="Rinki">Rinki</MenuItem>
                                <MenuItem value="Anumita">Anumita</MenuItem>
                                <MenuItem value="Pradeep">Pradeep</MenuItem>
                                <MenuItem value="Nitesh">Nitesh</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <Typography variant="subtitle2" gutterBottom>
                                Allocated To
                            </Typography>
                            <Select
                                value={bulkAllocatedTo}
                                onChange={(e) => setBulkAllocatedTo(e.target.value)}
                                variant="outlined"
                                size="small"
                            >
                                <MenuItem value="all">No Change</MenuItem>
                                {approvedNgos.map(ngo => (
                                    <MenuItem key={ngo} value={ngo}>{ngo}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <FormControl fullWidth>
                            <Typography variant="subtitle2" gutterBottom>
                                Distributed
                            </Typography>
                            <Select
                                value={bulkDistributed}
                                onChange={(e) => setBulkDistributed(e.target.value)}
                                variant="outlined"
                                size="small"
                            >
                                <MenuItem value="all">No Change</MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            sx={{ mt: 2 }}
                            onClick={handleBulkUpdate}
                            disabled={
                                bulkAssignedTo === 'all' &&
                                bulkAllocatedTo === 'all' &&
                                bulkDistributed === 'all'

                            }
                        >
                            Apply All Changes
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
};

export default BulkEditPanel;